import './ToolbarRow.css';

import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { ToolbarButton } from 'react-viewerbase';
import { commandsManager, extensionManager } from './../App.js';

import ConnectedCineDialog from './ConnectedCineDialog';
import ConnectedLayoutButton from './ConnectedLayoutButton';
import { MODULE_TYPES } from 'ohif-core';
import PropTypes from 'prop-types';
import qs from 'query-string';
import { logoutStorage } from '../utils';
import cornerstoneTools from 'cornerstone-tools';
import { apis } from '../api/index.js';
import { message } from 'antd';
import { eventListener } from '../utils';

class CTToolbarRow extends Component {
  static propTypes = {
    activeContexts: PropTypes.arrayOf(PropTypes.string).isRequired,
    onLocationLabelsUpdated: PropTypes.func.isRequired,
    extensionId: PropTypes.string.isRequired,
    applicationInfo: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const toolbarButtonDefinitions = this.getVisibleToolbarButtons.call(this);
    // TODO:
    // If it's a tool that can be active... Mark it as active?
    // - Tools that are on/off?
    // - Tools that can be bound to multiple buttons?

    // Normal ToolbarButtons...
    // Just how high do we need to hoist this state?
    // Why ToolbarRow instead of just Toolbar? Do we have any others?
    const search = qs.parse(window.location.search);
    this.state = {
      ...search,
      toolbarButtons: toolbarButtonDefinitions,
      activeButtons: [],
      isCineDialogOpen: false,
    };

    const panelModules = extensionManager.modules[MODULE_TYPES.PANEL];
    this.buttonGroups = { left: [], right: [] };
    const { extensionId } = this.props;

    panelModules.forEach(panelExtension => {
      const panelModule = panelExtension.module;
      const defaultContexts = Array.from(panelModule.defaultContext);
      if (extensionId !== panelExtension.extensionId) return;
      // MENU OPTIONS
      panelModule.menuOptions.forEach(menuOption => {
        const contexts = Array.from(menuOption.context || defaultContexts);

        const activeContextIncludesAnyPanelContexts = this.props.activeContexts.some(
          actx => contexts.includes(actx)
        );
        if (activeContextIncludesAnyPanelContexts) {
          const menuOptionEntry = {
            value: menuOption.target,
            icon: menuOption.icon,
            bottomLabel: menuOption.label,
          };
          const from = menuOption.from || 'right';

          this.buttonGroups[from].push(menuOptionEntry);
        }
      });
    });
  }

  componentDidMount() {
    this.props.onLocationLabelsUpdated([]);

    // 退出登录后自动关闭页面
    logoutStorage(window.close);
  }

  componentDidUpdate(prevProps) {
    const activeContextsChanged =
      prevProps.activeContexts !== this.props.activeContexts;

    if (activeContextsChanged) {
      this.setState({
        toolbarButtons: this.getVisibleToolbarButtons.call(this),
      });
    }

    const { activeButtons } = this.state;

    if (activeButtons.includes('StackScroll')) {
      const synchronizer = new cornerstoneTools.Synchronizer(
        // Cornerstone event that should trigger synchronizer
        'cornerstonenewimage',
        // Logic that should run on target elements when event is observed on source elements
        cornerstoneTools.updateImageSynchronizer
      );
      cornerstoneTools.addTool(cornerstoneTools.ReferenceLinesTool);
      cornerstoneTools.setToolEnabled('ReferenceLines', {
        synchronizationContext: synchronizer,
      });
    }
  }

  layoutButtonClick = visible => {
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    let elementId = visible ? 'ns-016' : 'ns-015';
    eventListener({ ...eventData, elementId });
  };

  layoutOnChange = selectedCell => {
    const { row, col } = selectedCell;
    const { productionId, pageId } = this.state;
    const eventData = { productionId, pageId, moduleId: 'mk0001' };
    let elementId;
    // 1*1
    if (row === 0 && col === 0) elementId = 'ns-017';
    // 1*2
    else if (row === 0 && col === 1) elementId = 'ns-018';
    // 2*1
    else if (row === 1 && col === 0) elementId = 'ns-019';
    // 2*2
    else if (row === 1 && col === 1) elementId = 'ns-020';
    elementId && eventListener({ ...eventData, elementId });
  };

  /**
   * Determine which extension buttons should be showing, if they're
   * active, and what their onClick behavior should be.
   */
  getButtonComponents = (toolbarButtons, activeButtons) => {
    return toolbarButtons.map((button, index) => {
      if (button.buttons && button.buttons.length) {
        return (
          <div key={index}>
            <ToolbarButton
              className="toolbar-button expandableToolMenu"
              key={button.id}
              label={button.label}
              icon={button.icon}
              onClick={() => this.handleToolbarButtonClick(button)}
              isActive={activeButtons.includes(button.id)}
            />
            {button.childrenState && (
              <div className="toolChildren">
                {button.buttons.map(child => (
                  <ToolbarButton
                    key={child.id}
                    label={child.label}
                    icon={child.icon}
                    onClick={() => this.handleToolbarButtonClick(child)}
                    isActive={activeButtons.includes(child.id)}
                  />
                ))}
              </div>
            )}
          </div>
        );
      }
      return (
        <ToolbarButton
          key={button.id}
          label={button.label}
          icon={button.icon}
          onClick={() => this.handleToolbarButtonClick(button)}
          isActive={activeButtons.includes(button.id)}
        />
      );
    });
  };

  /**
   * A handy way for us to handle different button types. IE. firing commands for
   * buttons, or initiation built in behavior.
   *
   * @param {*} button
   * @param {*} evt
   * @param {*} props
   */
  handleToolbarButtonClick = (button, evt, props) => {
    if (button.commandName) {
      const options = Object.assign({ evt }, button.commandOptions);
      commandsManager.runCommand(button.commandName, options);
    }

    if (['transform', 'More'].includes(button.id)) {
      button.childrenState = !button.childrenState;
    }
    this.setState({ activeButtons: [button.id] });
    if (button.type === 'setToolActive')
      this.setState({ activeButtons: [button.id] });
    else if (button.type === 'builtIn') this.handleBuiltIn(button.options);

    if (button.id === 'Download') {
      this.downloadDcm();
    }
  };

  downloadDcm = () => {
    message.loading('正在打包', 0);
    const record = this.props.applicationInfo;
    apis.ctDownloadDcm(record.diagId).then(url => {
      message.destroy();
      url = `/ai-web-ct${url}`;
      message.info('正在下载', 3);

      let link = document.createElement('a');
      link.href = url;

      let name = url.split('/');
      let len = name.length;
      name = name[len - 1];

      link.download = name;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    });
  };

  /**
   *
   */
  getVisibleToolbarButtons = () => {
    const toolbarModules = extensionManager.modules[MODULE_TYPES.TOOLBAR];
    const toolbarButtonDefinitions = [];
    toolbarModules.forEach(extension => {
      const { definitions, defaultContext } = extension.module;
      definitions.forEach(definition => {
        const context = definition.context || defaultContext;

        if (this.props.activeContexts.includes(context))
          toolbarButtonDefinitions.push(definition);
      });
    });

    return toolbarButtonDefinitions;
  };
  handleBuiltIn = ({ behavior } = {}) => {
    if (behavior === 'CINE') {
      const open = !this.state.isCineDialogOpen;
      this.setState({ isCineDialogOpen: open });
    }
  };

  render() {
    const buttonComponents = this.getButtonComponents.call(
      this,
      this.state.toolbarButtons,
      this.state.activeButtons
    );

    const cineDialogContainerStyle = {
      display: this.state.isCineDialogOpen ? 'block' : 'none',
      position: 'absolute',
      top: '82px',
      zIndex: 999,
    };

    return (
      <>
        <div className="ToolbarRow">
          {buttonComponents}
          <ConnectedLayoutButton
            layoutButtonClick={this.layoutButtonClick}
            layoutOnChange={this.layoutOnChange}
          />
        </div>
        <div className="CineDialogContainer" style={cineDialogContainerStyle}>
          <ConnectedCineDialog />
        </div>
      </>
    );
  }
}

export default withRouter(CTToolbarRow);
